// extracted by mini-css-extract-plugin
var _1 = "CourseCover_block__3663f";
var _2 = "CourseCover_displayErrorWrapper__07a5f";
var _3 = "CourseCover_editorBlockLink__d56cf";
var _4 = "CourseCover_emptyBlock__3bbc4";
var _5 = "CourseCover_footerNav__3eeaf";
var _6 = "CourseCover_root__b41cd";
export { _1 as "block", _2 as "displayErrorWrapper", _3 as "editorBlockLink", _4 as "emptyBlock", _5 as "footerNav", _6 as "root" }
